import { Helmet } from 'react-helmet-async';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';
import { PdfBackgroundsContent } from './components/PdfBackgroundsContent';

const TicketTemplates: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Ticketvorlagen | Starjack Admin</title>
            </Helmet>
            <PdfBackgroundsContent />
        </>
    );
};

TicketTemplates.isProtected = true;
TicketTemplates.permissions = [Permission.MAIL_CONFIGURATION_NAV];
TicketTemplates.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

export default TicketTemplates;
